import { NewDynamicTab } from "../../../components/Page";
import { JvvnlOverview } from "../../../config/DefaultDates";
import { JvvnlTitle, TabSwitcher } from "../Jvnnl_Dashboard";
import JvvnlGlobalSearch from "../../../components/Search/Jvvnl/GlobalSearch";
import { JvvnlFeederDemand } from "./FeederDemand";

export function JvvnlOverviewTab() {
  return (
    <NewDynamicTab
      headerPrefixComponent={<TabSwitcher />}
      rightPrefixComponent={<JvvnlGlobalSearch />}
      defaultDates={JvvnlOverview}
      header="Net Load & DRE Flow"
      showTabs={false}
      middleComponent={<JvvnlTitle />}
      tabs={{
        Overview: <JvvnlFeederDemand />,
      }}
    />
  );
}
